import { render } from "./CoverageTable.vue?vue&type=template&id=0cfd937b&scoped=true"
import script from "./CoverageTable.vue?vue&type=script&lang=js"
export * from "./CoverageTable.vue?vue&type=script&lang=js"

import "./CoverageTable.vue?vue&type=style&index=0&id=0cfd937b&scoped=true&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfd937b"]])

export default __exports__